<ion-header>
  <ion-toolbar>
    <ion-title>{{title}}</ion-title>
  </ion-toolbar>
</ion-header>

<ion-content>
  <p class="description">{{description}}</p>

  <ion-button class="action-btn" (click)="onDismiss(true)">
    {{okBtnText}}
  </ion-button>

  <br />

  <ion-button class="cancel-btn" fill="outline" (click)="onDismiss(false)">
    {{cancelBtnText}}
  </ion-button>
</ion-content>
